import React from "react";
//#region redux
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { GenericDocumentTodoFooterProps } from "models/propTypes/documentPropTypes";
import { genericDocumentSentBackApproved } from "store/actions/genericDocumentActions";
//#endregion
//#region components
import { PageFooter } from "components/common";
import GenericDocumentTodoMoreActions from "./footerMoreActions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const GenericDocumentTodoFooter: React.FC<GenericDocumentTodoFooterProps> = (props) => {
  const { genericDocument } = props;

  const dispatch = useDispatch();

  const onGenericDocumentApproveSuccess = () => {
    props.markAsDoneHandler && props.markAsDoneHandler();
    dispatch(genericDocumentSentBackApproved(genericDocument.id));
  };

  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit),
          onClick: props.onTodoClear,
          type: StyleEnums.DisplayType.Success,
          onActionSuccess: onGenericDocumentApproveSuccess,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Document.GenericDocumentSentBackTodoSubmitSuccess
          ),
        },
      ]}
      moreActions={
        <GenericDocumentTodoMoreActions genericDocument={genericDocument} markAsDoneHandler={props.markAsDoneHandler} />
      }
      disableSuccessMessages
    />
  );
};

export default GenericDocumentTodoFooter;
